import style from './LoadingScreen.module.css'

export default function LoadingScreen() {
    return(
        <dialog className={style.loadingDialog}>
            Loading...
        </dialog>
    );
}

//How to open and close
//document.querySelector("dialog").showModal()
//document.querySelector("dialog").close() 